import React from 'react';
import { Badge } from 'reactstrap';

const SeverityTag = (props) => {
    const value = (!props.value && props.value !== 0) ? -1 : props.value;
    const textAndColors = {
        unknown: {
            title: 'Unknown',
            color: 'secondary'
        },
        informational: {
            title: 'Informational',
            color: 'best'
        },
        low: {
            title: 'Low',
            color: 'low'
        },
        medium: {
            title: 'Medium',
            color: 'medium'
        },
        high: {
            title: 'High',
            color: 'high'
        },
        critical: {
            title: 'Critical',
            color: 'critical'
        }
    };

    const getSeverityTextColor = (value) => {
        let checkValue = typeof value === 'string' ? parseInt(value) : value;
        if (isNaN(checkValue)) {
            checkValue = value.toLowerCase();  
        }

        switch (checkValue) {
            case 'informational': 
            case 0:
                return textAndColors.informational;
            case 'low': 
            case 1:
                return textAndColors.low;
            case 'medium':
            case 2:
                return textAndColors.medium;
            case 'high':
            case 3:
                return textAndColors.high;
            case 'critical':
            case 4:
                return textAndColors.critical;
            default:
                return textAndColors.unknown;
        }
    };

    const severity = getSeverityTextColor(value);

    return (
        <Badge color={severity.color} className={`badge-soft-${severity.color}`}>
            {props.text || severity.title}
        </Badge>
    );
};

export default SeverityTag;
